import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  setDrawerFirstOpened,
  setDrawerOpen,
  setSearchDrawerOpen
} from '../../../../redux/slices/mapSlice';
import { useRouter } from 'next/router';
import ThinArrowIcon from '../../../../new-components/svg-icons/ThinArrowIcon';
import { useTranslation } from 'next-i18next';

const CloseButton = () => {
  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);
  const dispatch = useDispatch();
  const { t } = useTranslation('map');
  const { locale } = useRouter();
  const arrowStyles = (): React.CSSProperties => {
    if (locale === 'ar') {
      return {
        transform: 'rotate(180deg)'
      };
    }
    return {
      transform: 'rotate(0deg)'
    };
  };

  const handleClick = () => {
    dispatch(setDrawerOpen(true));
    dispatch(setDrawerFirstOpened(false));
    dispatch(setSearchDrawerOpen(true));
  };

  return !drawerOpen ? (
    <Container onClick={handleClick}>
      <ThinArrowIcon stroke="#000" styles={arrowStyles()} />
      <span>{t('compounds_on_map')}</span>
    </Container>
  ) : null;
};

const Container = styled.button`
  position: absolute;
  top: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #fff;
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 4px;
  transition:
    left,
    right 0.5s ease-in;
  inset-inline-end: 0;
  span {
    font-size: 14px;
    font-family: materialLight;
  }
  z-index: 9;
`;

export default CloseButton;
